import {
    IContestCashbackGoal,
    IContestCashbackOffer,
    IContestSpecialPeriod,
} from '@/components_v3/affiliate/contest/entities/cashback-offer/model/types';
import type { ContestOfferDraft } from '@/components_v3/affiliate/contest/model/types';

export function specialPeriodKey(period: IContestSpecialPeriod | null): string {
    if (!period) {
        return '';
    }

    return `${period.from}:${period.to}`;
}

export function cloneDraft(source: ContestOfferDraft): ContestOfferDraft {
    return {
        offerId: source.offerId,
        offerName: source.offerName,
        plan: source.plan,
        goals: source.goals.map((goal) => ({ ...goal })),
        specialPeriodEnabled: source.specialPeriodEnabled,
        specialPeriod: source.specialPeriod ? { ...source.specialPeriod } : null,
    };
}

export function draftFromOffer(offer: IContestCashbackOffer): ContestOfferDraft {
    return {
        offerId: offer.offerId,
        offerName: offer.offerName,
        plan: offer.customGoal ?? null,
        goals: offer.goals.map((goal) => ({ ...goal })),
        specialPeriodEnabled: offer.specialPeriodEnabled,
        specialPeriod: offer.specialPeriod ? { ...offer.specialPeriod } : null,
    };
}

export function emptyDraft(): ContestOfferDraft {
    return {
        offerId: null,
        offerName: null,
        plan: null,
        goals: [],
        specialPeriodEnabled: false,
        specialPeriod: null,
    };
}

export function bonusesKey(goals: IContestCashbackGoal[]): string {
    return goals
        .map((goal) => `${goal.legacy_id}:${goal.bonus ?? ''}:${goal.periodBonus ?? ''}`)
        .join('|');
}
